<template>
  <div>
    
    <b-container fluid>
      <b-breadcrumb class="mt-3 mb-3" :items="breadcrumb_items"/>

      <b-card class="mb-1">

        <b-form-group id="grp_txt_order_number" label="Order Number:" label-for="txt_order_number" label-size="sm">
          <b-form-input id="txt_order_number" type="text" required placeholder v-model="tracking.order_number"></b-form-input>
        </b-form-group>

        <b-form-group id="grp_txt_tracking_number" label="Tracking Number:" label-for="txt_tracking_number" label-size="sm">
          <b-form-input id="txt_tracking_number" type="text" required placeholder v-model="tracking.tracking_number"></b-form-input>
        </b-form-group>

        <b-form-group id="grp_txt_courier" label="Courier:" label-for="txt_courier" label-size="sm">
          <b-form-input id="txt_courier" type="text" required placeholder v-model="tracking.courier_short_name"></b-form-input>
        </b-form-group>

        <b-form-group id="grp_txt_attention" label="Attention:" label-for="txt_attention" label-size="sm">
          <b-form-input id="txt_attention" type="text" required placeholder v-model="tracking.attention"></b-form-input>
        </b-form-group>

        <b-form-group id="grp_txt_phone" label="Phone:" label-for="txt_phone" label-size="sm">
          <b-form-input id="txt_phone" type="text" required placeholder v-model="tracking.phone"></b-form-input>
        </b-form-group>

        <b-form-group id="grp_txt_address" label="Address:" label-for="txt_address" label-size="sm">
          <b-form-input id="txt_address" type="text" required placeholder v-model="tracking.address"></b-form-input>
        </b-form-group>

        <b-form-group id="grp_txt_remark" label="Remark:" label-for="txt_remark" label-size="sm">
          <b-form-input id="txt_remark" type="text" required placeholder v-model="tracking.remark"></b-form-input>
        </b-form-group>

        <b-form-group id="grp_txt_district" label="District:" label-for="txt_district" label-size="sm">
          <b-form-input id="txt_district" type="text" required placeholder v-model="tracking.district"></b-form-input>
        </b-form-group>

        <b-form-group id="grp_txt_route" label="Route:" label-for="txt_route" label-size="sm">
          <b-form-input id="txt_route" type="text" required placeholder v-model="tracking.route"></b-form-input>
        </b-form-group>

        <b-form-group id="grp_txt_scheduled_delivery_date" label="Scheduled Delivery Date:" label-for="txt_scheduled_delivery_date" label-size="sm">
          <b-form-input id="txt_scheduled_delivery_date" type="text" required placeholder v-model="tracking.scheduled_delivery_date"></b-form-input>
        </b-form-group>

        <b-form-group id="grp_txt_packing_seq" label="Packing Seq:" label-for="txt_packing_seq" label-size="sm">
          <b-form-input id="txt_packing_seq" type="text" required placeholder v-model="tracking.packing_seq"></b-form-input>
        </b-form-group>

        <b-form-group id="grp_txt_packing_sector" label="Packing Sector:" label-for="txt_packing_sector" label-size="sm">
          <b-form-input id="txt_packing_sector" type="text" required placeholder v-model="tracking.packing_sector"></b-form-input>
        </b-form-group>

        <b-form-group id="grp_txt_redemption_code" label="Redemption Store:" label-for="txt_redemption_code" label-size="sm">
          <b-form-input id="txt_redemption_code" type="text" required placeholder v-model="tracking.redemption_code"></b-form-input>
        </b-form-group>

        <b-form-group id="grp_txt_payment_type" label="Payment Type:" label-for="txt_payment_type" label-size="sm">
          <!-- <b-form-input id="txt_payment_type" type="text" required placeholder v-model="tracking.payment_type"></b-form-input> -->
          <b-form-select
            size="sm"
            v-model="tracking.payment_type"
            :options="payment_type_options"
          />
        </b-form-group>

        <b-form-group id="grp_txt_payment_status" label="Payment Status:" label-for="txt_payment_status" label-size="sm">
          <!-- <b-form-input id="txt_payment_status" type="text" required placeholder v-model="tracking.payment_status"></b-form-input> -->
          <b-form-select
            size="sm"
            v-model="tracking.payment_status"
            :options="payment_status_options"
          />
        </b-form-group>

        <b-form-group id="grp_txt_payment_amount" label="Payment Amount:" label-for="txt_payment_amount" label-size="sm">
          <b-form-input id="txt_payment_amount" type="text" required placeholder v-model="tracking.payment_amount"></b-form-input>
        </b-form-group>

        <b-form-group id="grp_txt_payment_paid" label="Payment Paid:" label-for="txt_payment_paid" label-size="sm">
          <b-form-input id="txt_payment_paid" type="text" required placeholder v-model="tracking.payment_paid"></b-form-input>
        </b-form-group>

        <b-form-group id="grp_txt_payment_ref" label="Payment Ref:" label-for="txt_payment_ref" label-size="sm">
          <b-form-input id="txt_payment_ref" type="text" required placeholder v-model="tracking.payment_ref"></b-form-input>
        </b-form-group>

        <b-form-group id="grp_txt_packing_remark" label="Packing Remark:" label-for="txt_packing_remark" label-size="sm">
          <b-form-input id="txt_packing_remark" type="text" required placeholder v-model="tracking.packing_remark"></b-form-input>
        </b-form-group>

        <!-- <b-button class="float-right" type="submit" variant="primary" @click="submitForm()">Submit</b-button> -->

      </b-card>

      <h4 v-if="false" class="mt-3">
        Products
      </h4>

      <b-card v-if="false">
        <b-table
          responsive
          small
          outlined
          striped
          hover
          :items="order_master_products"
          :fields="product_fields"
        >
          <template v-slot:cell(cover_image)="data">
            <img :src="data.item.cover_image" width="50" />
          </template>

          <template v-slot:cell(product_qty)="data">
            <b-form-input type="text" required placeholder v-model="data.item.product_qty"></b-form-input>
          </template>
          <template v-slot:cell(action)="data">
            <b-button
              class="btn-action"
              size="sm"
              variant="danger"
              v-if="$store.state.user_obj.account_type != 'young_living'"
              @click.stop="showModal_cancelTracking(data.item)"
              >Delete</b-button
            >
          </template>
        </b-table>
      </b-card>

      <b-button class="mt-3 float-right" type="submit" variant="primary" @click="submitForm()">Submit</b-button>
    </b-container>
  </div>
</template>

<script>
import moment from "moment";
import VueBarcode from "vue-barcode";

const fields = [
  {
    key: "order_id",
    label: "Order#"
  },
  {
    key: "barcode",
    label: "Barcode"
  },
  {
    key: "attention",
    label: "Attention"
  },
  {
    key: "phone",
    label: "Phone"
  },
  {
    key: "status",
    label: "Status"
  },
  {
    key: "schedule_date",
    label: "Scheduled Date"
  },
  {
    key: "pod_image",
    label: "POD Record"
  },
  {
    key: "carried_by",
    label: "Carried by"
  },
  {
    key: "updated_at",
    label: "Last Updated"
  }
];

export default {
  name: "TrackingEdit",
  inject: ["API_HOST", "TABLE_LIMIT", "PAGING_LIMIT"],
  components: {
    barcode: VueBarcode
  },
  data() {
    return {
      order_master_products: [],
      product_fields: [
        {
          key: "cover_image",
          label: ""
        },
        {
          key: "product_sku",
          label: "Product SKU"
        },
        {
          key: "product_price",
          label: "Price"
        },
        {
          key: "product_qty",
          label: "Quantity"
        }
      ],
      breadcrumb_items: [
        {
          text: "Trackings",
          to: { name: "trackings" }
        },
        {
          text: "Edit",
          active: true
        }
      ],
      tracking : {},
      history_items: [],
      history_fields: [
        {
          key: "updated_at",
          label: "Updated at"
        },
        {
          key: "status",
          label: "Status"
        },
        {
          key: "pod_image",
          label: "POD"
        },
        {
          key: "updated_by",
          label: "Updated by"
        }
      ],
      loader: false,
      items: [],
      fields: fields,
      currentPage: 1,
      table_offset: 0,
      total_rows: 0,
      manual_return_order_id: "",
      updating_item: false,
      search_criteria: {
        keyword: "",
        status_selected: null
      },
      payment_type_options: [
        {
          value: '-',
          text: "-"
        },
        {
          value: 'cash',
          text: "Cash"
        },
        {
          value: 'payme',
          text: "Payme"
        },
        {
          value: 'octopus',
          text: "Octopus"
        },
        {
          value: 'others',
          text: "Others"
        },
      ],
      payment_status_options: [
        {
          value: null,
          text: "-"
        },
        {
          value: 'Pending',
          text: "Pending"
        },
        {
          value: 'Partial Paid',
          text: "Partial Paid"
        },
        {
          value: 'Fully Paid',
          text: "Fully Paid"
        },
      ],
      status_options: [
        {
          value: null,
          text: "All Status"
        },
        {
          value: "Pending",
          text: "Pending"
        },
        {
          value: "In-Transit",
          text: "In-Transit"
        },
        {
          value: "Returning to GOLS Warehouse",
          text: "Returning to GOLS Warehouse"
        },
        {
          value: "Successful Delivery",
          text: "Successful Delivery"
        },
        {
          value: "Returned to Warehouse",
          text: "Returned to Warehouse"
        }
      ],
      reschedule_type_selected: "before",
      reschedule_type_options: [
        {
          value: "before",
          text: "before"
        },
        {
          value: "on",
          text: "on"
        },
        {
          value: "after",
          text: "after"
        }
      ],
      reschedule_date: moment().format("YYYY-MM-DD"),
      showAlert_success: false,
      alert_success_message: "",
      user_id : false
    };
  },
  async created() {
    await this.getTracking();
    await this.getOrderMasterProduct();
    this.initialized = true;
  },
  mounted() {
    this.loader = this.$loading.show({
      isFullPage: true,
      canCancel: false
    });
  },
  methods: {
    displayDate(d) {
      if (d) {
        return moment(d).format("YYYY-MM-DD");
      } else {
        return "/";
      }
    },

    async getTracking() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "tracking_get.php",
        data: {
          tracking_id: this.$route.params.id,
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id
        }
      });

      if(response.data.trackings[0].attention_driver){
        response.data.trackings[0].attention = response.data.trackings[0].attention_driver;
      }

      if(response.data.trackings[0].phone_driver){
        response.data.trackings[0].phone = response.data.trackings[0].phone_driver;
      }

      if(response.data.trackings[0].address_driver){
        response.data.trackings[0].address = response.data.trackings[0].address_driver;
      }

      this.tracking = response.data.trackings[0];
      this.items.push(this.tracking);

      this.history_items = response.data.tracking_status_historys;
      this.loader.hide();
    },

    showModal_reschedule_tracking(item) {
      this.updating_item = item;
      this.reschedule_type_selected = "before";
      this.reschedule_date = moment().format("YYYY-MM-DD");
      this.$refs.modal_reschedule_tracking.show();
    },

    hideModal_reschedule_tracking() {
      this.$refs.modal_reschedule_tracking.hide();
    },

    submitForm() {
      this.updateTracking(this.tracking);
    },

    async updateTracking(
      tracking_obj
    ) {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "tracking_detail_update.php",
        data: {
          id: tracking_obj.id,
          tracking_number: tracking_obj.tracking_number,
          attention : tracking_obj.attention,
          phone : tracking_obj.phone,
          address : tracking_obj.address,
          remark: tracking_obj.remark,
          district : tracking_obj.district,
          route : tracking_obj.route,
          scheduled_delivery_date : tracking_obj.scheduled_delivery_date,
          packing_seq : tracking_obj.packing_seq,
          packing_sector : tracking_obj.packing_sector,
          redemption_code : tracking_obj.redemption_code,
          payment_type : tracking_obj.payment_type,
          payment_status : tracking_obj.payment_status,
          payment_amount : tracking_obj.payment_amount,
          payment_paid : tracking_obj.payment_paid,
          payment_ref : tracking_obj.payment_ref,
          order_number : tracking_obj.order_number,
          packing_remark: tracking_obj.packing_remark,
          courier_short_name : tracking_obj.courier_short_name,
          user_id: this.$store.state.user_obj.user_id,
          client_id: this.$store.state.user_obj.client_id
        }
      });

      if (response.data.status == "success") {
        this.$eventHub.$emit("show_modal_message", {
            message_content: `Tracking Update Successfully.`
        });
        this.getTracking();
      } else {
      }
    },
    async getOrderMasterProduct() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_master_product_get.php",
        data: {
          order_number: this.tracking.order_number,
          account_type: this.$store.state.user_obj.account_type,
          client_id: this.$store.state.user_obj.client_id
        }
      });

      this.order_master_products = response.data.products;

      this.loader.hide();
    }
  }
};
</script>

<style>
th,
td {
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/TrackingEdit.vue